import memberDetailsService from "@services/memberDetails.service";
import { Form, FormInstance } from "antd";
import React, { createContext, useContext, useState } from "react";
import { useVitalsContext } from "../../useVitals";

export type UseEditProps = {
  close: (shouldRefresh: boolean) => void
};

export type UseEdit = (props: UseEditProps) => {
  loading?: boolean
  form?: FormInstance<any>
  onSubmit?: (values: any) => void
};

export const useEdit: UseEdit = function (props) {
  const {
    patientID
  } = useVitalsContext()
  const [loading, setloading] = useState<boolean>(false)

  const [form] = Form.useForm()

  const onSubmit = (values: any) => {
    if (!loading) {
      setloading(true)
      memberDetailsService.updateVital(patientID, values.weight, values.date )
        .subscribe((response) => {
          console.log('updated successfully')
          props.close(true)
        },
        err => {
          setloading(false)
        })
    }
  }

  return {
    loading,
    form,
    onSubmit
  };
};

export const EditContext = createContext<ReturnType<UseEdit>>({});

export const EditProvider: React.FC<UseEditProps> = function ({ children, ...props }) {
  const editValue = useEdit(props);

  return <EditContext.Provider value={editValue}>{children}</EditContext.Provider>;
};

export const useEditContext = () => useContext(EditContext);
